import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-60173692"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "section" }
const _hoisted_2 = { class: "section--header" }
const _hoisted_3 = { class: "bold" }
const _hoisted_4 = { class: "section--body" }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "section" }
const _hoisted_7 = { class: "section--header" }
const _hoisted_8 = { class: "bold" }
const _hoisted_9 = { class: "section--body" }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 0,
  class: "section"
}
const _hoisted_12 = { class: "section--header" }
const _hoisted_13 = { class: "bold" }
const _hoisted_14 = { class: "section--body" }
const _hoisted_15 = {
  key: 0,
  class: "case-wrapper"
}
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "case__inner" }
const _hoisted_18 = { class: "case--info" }
const _hoisted_19 = { class: "bold" }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = {
  key: 1,
  class: "section"
}
const _hoisted_22 = { class: "section--header" }
const _hoisted_23 = { class: "bold" }
const _hoisted_24 = { class: "section--body" }
const _hoisted_25 = { class: "author" }
const _hoisted_26 = ["src"]
const _hoisted_27 = { class: "author__name" }
const _hoisted_28 = { class: "section" }
const _hoisted_29 = { class: "section--body" }
const _hoisted_30 = { class: "time-wrapper" }
const _hoisted_31 = { class: "time" }
const _hoisted_32 = { class: "bold" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_34 = {
  key: 0,
  class: "time"
}
const _hoisted_35 = { class: "bold" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_drive_shared_bar = _resolveComponent("drive-shared-bar")!
  const _component_app_label_input = _resolveComponent("app-label-input")!
  const _component_app_label = _resolveComponent("app-label")!
  const _component_item_case = _resolveComponent("item-case")!
  const _component_app_bottom_pop_up = _resolveComponent("app-bottom-pop-up")!

  return (_openBlock(), _createBlock(_component_app_bottom_pop_up, {
    onHide: _ctx.hidePopUp,
    "hide-bottom-decoration": "",
    "hide-top-decoration": ""
  }, {
    title: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.isPhoto ? _ctx.$localize('media.info.popup.type.photo') : _ctx.$localize('media.info.popup.type.file')) + " " + _toDisplayString(_ctx.$localize('media.info.popup.type.info')), 1)
    ]),
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h5", _hoisted_3, _toDisplayString(_ctx.$localize('media.info.popup.shared')), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          (_ctx.sharedTo)
            ? (_openBlock(), _createBlock(_component_drive_shared_bar, {
                key: 0,
                "show-delete": ""
              }))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$localize('media.info.popup.shared.none')), 1))
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("h5", _hoisted_8, _toDisplayString(_ctx.$localize('media.info.popup.labels')), 1),
          (!_ctx.isShared && false)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass(["icon", [_ctx.isEditLabels ? 'icon-check' : 'icon-edit']]),
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addLabels && _ctx.addLabels(...args)))
              }, null, 2))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_9, [
          (_ctx.isEditLabels)
            ? (_openBlock(), _createBlock(_component_app_label_input, {
                key: 0,
                isFile: "",
                focus: ""
              }))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mainStore.inputFileTags, (label) => {
                  return (_openBlock(), _createBlock(_component_app_label, {
                    key: label.id
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(label.text), 1)
                    ]),
                    _: 2
                  }, 1024))
                }), 128)),
                (!_ctx.mainStore.inputFileTags.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.$localize('media.info.popup.no.labels')), 1))
                  : _createCommentVNode("", true)
              ], 64))
        ])
      ]),
      (!_ctx.isShared)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("h5", _hoisted_13, _toDisplayString(_ctx.$localize('media.info.popup.case.info')), 1)
            ]),
            _createElementVNode("div", _hoisted_14, [
              (_ctx.cases.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cases, (iCase) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "case",
                        key: iCase.id!,
                        onClick: ($event: any) => (_ctx.goToCase(iCase.id!))
                      }, [
                        _createElementVNode("div", _hoisted_17, [
                          _createVNode(_component_item_case, {
                            iCase: iCase,
                            hideTitle: ""
                          }, null, 8, ["iCase"])
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("h5", _hoisted_19, _toDisplayString(iCase.title), 1),
                          _createElementVNode("p", null, _toDisplayString(iCase.description || _ctx.$localize('media.info.popup.no.case.description')), 1)
                        ])
                      ], 8, _hoisted_16))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_ctx.$localize('media.info.popup.no.case.with.photo')), 1))
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isShared)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("h5", _hoisted_23, _toDisplayString(_ctx.$localize('media.info.popup.sharing.owner')), 1)
            ]),
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("img", {
                  class: "author__photo",
                  src: _ctx.authorPhotoUrl,
                  alt: ""
                }, null, 8, _hoisted_26),
                _createElementVNode("div", _hoisted_27, _toDisplayString(_ctx.fileOwner.firstName) + " " + _toDisplayString(_ctx.fileOwner.lastName), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("div", _hoisted_30, [
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("p", _hoisted_32, _toDisplayString(_ctx.$localize('media.info.popup.date.created')), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.createdDate), 1),
              _hoisted_33
            ]),
            (_ctx.sharedDate)
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                  _createElementVNode("p", _hoisted_35, _toDisplayString(_ctx.$localize('media.info.popup.date.shared')), 1),
                  _createElementVNode("p", null, _toDisplayString(_ctx.sharedDate), 1),
                  _hoisted_36
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["onHide"]))
}